import { MIN_WIDTH } from '../config/designSystem/MinWidth';
import { useWindowDimensions } from 'react-native';

interface Config {
  xl?: number;
  lg?: number;
  md?: number;
  sm: number;
}

/**
 * Returns a value based on the window width and width breakpoints.
 * @param cfg the widths to use for each breakpoint
 * @example
 *  // on small screens width is assigned to 10
 *  const width = useBreakpointWidth({sm: 10, md: 40, lg: 120})
 */
export const useBreakpointWidth = (cfg: Config) => {
  const {width} = useWindowDimensions();
  if (width > MIN_WIDTH.lg) {
    return cfg.xl || cfg.lg || cfg.md || cfg.sm;
  } else if (width > MIN_WIDTH.md) {
    return cfg.lg || cfg.md || cfg.sm;
  } else if (width > MIN_WIDTH.sm) {
    return cfg.md || cfg.sm;
  } else {
    return cfg.sm;
  }
};
